import styled from 'styled-components'

import { TextButton } from '../../../Buttons'
import { Table } from '../../../Table'

export const ActionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 10px 0 100px;
`

export const DeleteButton = styled(TextButton)`
  padding: 0;
  height: auto;
  margin-right: 20px;
`

export const FilesTable = styled(Table)`
  margin-bottom: 0;

  > table {
    border-bottom: none;
  }
`

export const ButtonSPart = styled.span`
  text-transform: lowercase;
`
